module.exports = __webpack_public_path__ + "img/3.11452b59.gif";